module.exports = __webpack_public_path__ + "static/media/recortes_home_02.ccb27b2b.jpg";